import type { SubMenuItemType } from '../../types/menu';

const menuTrackingSchema = (category: string, label: string, isMobile: boolean) => ({
  event: 'main_navigation',
  traits: {
    event_info: {
      navigation_category: category ?? '',
      navigation_selection: label ?? '',
      burger_menu: isMobile ? 'open' : 'closed',
      user_interaction: 'main_navigation_click',
    },
  },
});

export const trackMenuClick = <T extends (arg: ReturnType<typeof menuTrackingSchema>) => void>(
  tracker: T,
  options: {
    category: string | null | undefined;
    label: string | null | undefined;
    isMobile: boolean;
  },
) => {
  if (!options.category || !options.label) return;
  tracker(menuTrackingSchema(options.category, options.label, options.isMobile));
};

export const formatCardMenuItem = <T extends (arg: ReturnType<typeof menuTrackingSchema>) => void>(
  itemNodes: Array<SubMenuItemType> | undefined,
  options?: {
    tracker: T;
    category: string | null | undefined;
    isMobile: boolean;
  },
) =>
  Array.isArray(itemNodes)
    ? itemNodes.map((item: SubMenuItemType) => ({
        id: item.id,
        label: item.label,
        href: item.translatedPath,
        description: item.description,
        onClick: () => {
          options?.tracker?.(
            menuTrackingSchema(options?.category ?? '', item.label ?? '', options?.isMobile),
          );
        },
      }))
    : null;
